import { type Policy } from '@canvas/policies/types';

import { availableModes } from './modes';
import { AvailableModes, type Capabilities } from './types';

export class ApplicationModeManager {
  private currentMode: AvailableModes;
  private storedCapabilities: Capabilities;

  constructor(mode: AvailableModes = AvailableModes.readWrite) {
    this.storedCapabilities = availableModes[mode];
    this.currentMode = mode;
  }

  changeMode(mode: AvailableModes) {
    this.storedCapabilities = availableModes[mode];
    this.currentMode = mode;
  }

  capabilities(): Capabilities {
    return this.storedCapabilities;
  }
  mode(): AvailableModes {
    return this.currentMode;
  }
  policies(): Array<Policy> {
    return this.storedCapabilities.policies;
  }
}

export const applicationModeManager = new ApplicationModeManager();
